import { Component, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { ProductService } from 'src/app/product/product.service';
import { Product } from 'src/typings';

@Component({
  selector: 'app-add-to-product',
  templateUrl: './add-to-product.component.html',
  styleUrls: ['./add-to-product.component.scss']
})
export class AddToProductComponent {
  product: Product | undefined;

  dialog: MatDialogRef<AddToProductComponent> | undefined;

  @Output() doneEvent: EventEmitter<{ id: number; barcode: string }[]> = new EventEmitter();

  constructor(private fb: UntypedFormBuilder, private productService: ProductService) {}

  formGroup = this.fb.group({
    barcode: new UntypedFormControl()
  });

  get barcode() {
    return this.formGroup.value.barcode;
  }

  async save() {
    if (!this.product) return;
    try {
      const res = await this.productService
        .addBarcodeToProduct({
          product_id: this.product.id,
          barcode: this.barcode
        })
        .toPromise();
      this.doneEvent.emit(res);
    } catch (error: any) {
      if (Number(error?.status) !== 409) throw error;
      const message =
        error?.error?.message ||
        'Этот штрихкод уже используется другим товаром. Добавить его как общий?';
      if (!window.confirm(`${message}\n\nДобавить штрихкод и к текущему товару?`)) return;
      const res = await this.productService
        .addBarcodeToProduct({
          product_id: this.product.id,
          barcode: this.barcode,
          allow_shared: true
        })
        .toPromise();
      this.doneEvent.emit(res);
    }
  }
}
